import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { postData, fetchData } from "../../Services/apiService";
import { apiUrl } from '../../config/api';
import logo from '../../Img/AS-removebg-preview.png';
import "./ApplyCourse.css";

const studentTestimonials = [
    { quote: 'This workshop completely changed my understanding of the stock market. Highly recommended.', author: 'Rahul Sharma', detail: 'Workshop participant' },
    { quote: 'The sessions are simple, practical, and full of insights that I can apply in the market.', author: 'Priya Mehta', detail: 'Course participant' },
    { quote: 'Clear guidance and excellent support helped me build more confidence in my decisions.', author: 'Amit Verma', detail: 'Learning community member' },
];

const ApplyCourse = () => {

    const navigate = useNavigate();

    const { id, lectID } = useParams();
    const [searchParams] = useSearchParams();
    const sourceFromUrl = (
        searchParams.get("Source") ||
        searchParams.get("source") ||
        searchParams.get("utm_source") ||
        "Direct"
    ).trim().slice(0, 100) || "Direct";

    const [events, setEvents] = useState([]);
    const [offering, setOffering] = useState(null);
    const [loading, setLoading] = useState(false);
    const [courseLoading, setCourseLoading] = useState(true);
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        expired: false
    });

    useEffect(() => {
        const slider = setInterval(() => {
            setActiveTestimonial((current) => (current + 1) % studentTestimonials.length);
        }, 5500);

        return () => clearInterval(slider);
    }, []);

    const generateGUID = () => {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };

    // Generate Transaction ID only once
    const [trid] = useState(generateGUID());

    const [formData, setFormData] = useState({

        Fname: "",
        Mname: "",
        Lname: "",

        ContactNo: "",
        CountryCode: "+91",

        EmailID: "",

        State: "",
        City: "",
        Pincode: "",
        Address: "",

        AlternateNo: "",

        PaymentMode: "Online",
        PaymentStatus: "Not paid",

        Fees: "",

        CourceID: lectID,

        TransactionID: trid,

        Source: sourceFromUrl,

    });

    useEffect(() => {
        setFormData((previous) => ({
            ...previous,
            Source: sourceFromUrl,
        }));
    }, [sourceFromUrl]);

    const [showFormModal, setShowFormModal] = useState(false);
    /******************************************************
     * Load Course Information
     ******************************************************/
    useEffect(() => {

        const loadCourse = async () => {

            if (!lectID) return;

            try {

                setCourseLoading(true);

                const url = apiUrl(`ByID/Courses/${lectID}`);

                const data = await fetchData(url);

                setEvents(data || []);

                if (data && data.length > 0) {

                    const offeringData = await fetchData(
                        apiUrl(`ByType/Offerings/${data[0].CourseType}`)
                    );
                    setOffering(offeringData?.[0] || null);

                    setFormData(prev => ({
                        ...prev,
                        Fees: data[0].Fees || ""
                    }));

                }

            } catch (error) {

                console.error("Error loading course details:", error);

            } finally {

                setCourseLoading(false);

            }

        };

        loadCourse();

    }, [lectID]);

   
    /******************************************************
     * Course Information
     ******************************************************/
    const courseInfo =
        events && events.length > 0
            ? events[0]
            : null;


 useEffect(() => {

        if (!courseInfo?.CourseDate) return;

        // Convert Course Date to JavaScript Date
        // Expected format: YYYY-MM-DD
        const targetDate = new Date(courseInfo.CourseDate);

        // Set target to midnight (00:00:00) of course date
        targetDate.setHours(0, 0, 0, 0);

        const timer = setInterval(() => {

            const now = new Date();
            const difference = targetDate - now;

            if (difference <= 0) {

                clearInterval(timer);

                setCountdown({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    expired: true
                });

                return;
            }

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));

            const hours = Math.floor(
                (difference % (1000 * 60 * 60 * 24)) /
                (1000 * 60 * 60)
            );

            const minutes = Math.floor(
                (difference % (1000 * 60 * 60)) /
                (1000 * 60)
            );

            const seconds = Math.floor(
                (difference % (1000 * 60)) /
                1000
            );

            setCountdown({
                days,
                hours,
                minutes,
                seconds,
                expired: false
            });

        }, 1000);

        return () => clearInterval(timer);

    }, [courseInfo]);

    const numericFees = Number(courseInfo?.Fees || 0);
    const formattedFees = numericFees > 0
        ? numericFees.toLocaleString("en-IN")
        : "Free";

    /******************************************************
     * Handle Input Change
     ******************************************************/
    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };
    /******************************************************
     * Submit Registration
     ******************************************************/
    const handleSubmit = async (e) => {

        e.preventDefault();

        if (loading || countdown.expired) return;

        setLoading(true);

        const body = {
            Data: [
                {
                    RegID: "New",
                    ...formData,
                    RegisteredOn: new Date().toISOString()
                }
            ]
        };

        try {

            // ==========================
            // Generate OTP Flow
            // ==========================
            if (id === "0") {

                await postData(
                    apiUrl(`GenerateOTP/${formData.ContactNo}`),
                    body
                );

                navigate(
                    `/otpVerification/${formData.TransactionID}/${formData.ContactNo}/${formData.EmailID}/${formData.Fname}`
                );

                return;
            }

            // ==========================
            // Direct Registration Flow
            // ==========================

            await postData(
                apiUrl('Update/Registrations'),
                body
            );

            navigate(
                `/verifyRegistration/${formData.TransactionID}/${formData.Fname}/${formData.ContactNo}/${formData.EmailID}`
            );

        } catch (error) {

            console.error(error);

            alert(
                error?.message ||
                "Something went wrong while submitting your registration."
            );

        } finally {

            setLoading(false);

        }

    };

    return (
        <section className="apply-course-page">



                    <div className="hero-registration">
                        <div className="hero-overlay"></div>
                        <div className="row g-3 align-items-stretch position-relative apply-course-layout mt-2 mb-2">

                            {/* ================= LEFT SIDE ================= */}

                            <div className="col-lg-5">

                                <div className="course-card sticky-top-new">

                                    <div className="course-header">

                                        <span className="premium-badge">
                                            {formattedFees === "Free" ? "FREE MASTERCLASS" : "LIVE COURSE"}
                                        </span>

                                        <h2>
                                            {courseInfo?.CourseTitle || 'Course registration'}
                                        </h2>

                                        <h5>
                                            {courseInfo?.CourseType}
                                        </h5>



                                    </div>

                                    {courseLoading ? (

                                        <div className="text-center p-5">

                                            <div className="spinner-border text-success"></div>

                                        </div>

                                    ) : (

                                        <>
                                            <div className="trainer-card">



                                                <img
                                                    src={logo}
                                                    className="trainer-photo-large"
                                                    alt={courseInfo?.CourseBy
                                                        ?.substring(0, 1)
                                                        ?.toUpperCase()}
                                                />



                                                <h5>

                                                    {courseInfo?.CourseBy}

                                                </h5>

                                                <span>

                                                    SEBI Registered Research Analyst

                                                </span>

                                                <p className="trainer-summary">
                                                    Build confidence through live-market examples and structured risk management.
                                                </p>

                                                <ul className="trainer-credentials">
                                                    <li>NISM Series XV-A Certified</li>
                                                    <li>Market experience since 2008</li>
                                                    <li>Technical &amp; fundamental analysis</li>
                                                </ul>

                                            </div>
                                            <div className="stats-row">

                                                <div className="stat-box">
                                                    <h3>1K+</h3>
                                                    <span>Students</span>
                                                </div>

                                                <div className="stat-box">
                                                    <h3>4.9★</h3>
                                                    <span>Rating</span>
                                                </div>

                                                <div className="stat-box">
                                                    <h3>20+</h3>
                                                    <span>Batches</span>
                                                </div>

                                            </div>

                                            <div className="course-body">

                                                <div className="course-row">

                                                    <span>👨 Trainer</span>

                                                    <strong>{courseInfo?.CourseBy}</strong>

                                                </div>

                                                <div className="course-row">

                                                    <span>📅 Date</span>

                                                    <strong>{courseInfo?.CourseDate}</strong>

                                                </div>

                                                <div className="course-row">

                                                    <span>🕒 Time</span>

                                                    <strong>{courseInfo?.Time}</strong>

                                                </div>

                                                <div className="course-row">

                                                    <span>📍 Location</span>

                                                    <strong>{courseInfo?.CourseLocation}</strong>

                                                </div>

                                                <div className="course-row">

                                                    <span>🌐 Language</span>

                                                    <strong>{courseInfo?.Language}</strong>

                                                </div>

                                                <div className="course-row">

                                                    <span>💰 Fees</span>

                                                    <strong className="course-fees">

                                                        ₹ {formattedFees}

                                                    </strong>

                                                </div>

                                            </div>

                                            <hr />

                                            <div className="px-4 pb-4">

                                                <h5 className="mb-3">

                                                    What you'll learn

                                                </h5>

                                                <ul className="course-points">

                                                    {offering?.highlights?.map((point, index) => (

                                                        <li key={index}>

                                                            ✅ {point}

                                                        </li>

                                                    ))}

                                                </ul>

                                            </div>

                                        </>

                                    )}

                                </div>

                                {/*<div className="registration-counter">

                                    <span className="pulse-dot"></span>

                                    <b>

                                        186

                                    </b>

                                    People registered in last 24 Hours

                                </div>
                                */}

                            </div>

                            {/* ================= RIGHT SIDE ================= */}

                            <div id="registration-form" className="col-lg-7 d-block">

                                <div className="premium-form-card">

                                    {/* Header Section */}

                                    <div className="registration-header">

                                        <div>

                                            <span className="free-badge">
                                                {formattedFees === "Free" ? "FREE" : "PREMIUM"}
                                            </span>

                                            <h1 className="registration-title">
                                                {offering?.title || courseInfo?.CourseTitle || 'Course registration'}
                                            </h1>

                                            <p className="registration-subtitle">
                                                Fill your details and reserve your seat instantly.
                                            </p>

                                        </div>

                                        <div className="trainer-profile d-none d-md-block d-lg-block">



                                            <img
                                                src={logo}
                                                alt="Ajit Singh"
                                                className="trainer-photo"
                                            />



                                            <h6 className="trainer-name mt-3">
                                                {courseInfo?.CourseBy}
                                            </h6>

                                            <small className="text-muted">
                                                Your Trainer
                                            </small>

                                        </div>

                                    </div>

                                    <div className="premium-divider"></div>



                                    <form onSubmit={handleSubmit}>
                                        <fieldset className="registration-fields" disabled={countdown.expired || loading}>

                                        <div className="row g-4">

                                            <div className="col-md-4">

                                                <label className="premium-label">
                                                    First Name
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control premium-input"
                                                    name="Fname"
                                                    value={formData.Fname}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                            <div className="col-md-4">

                                                <label className="premium-label">
                                                    Middle Name
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control premium-input"
                                                    name="Mname"
                                                    value={formData.Mname}
                                                    onChange={handleChange}
                                                />

                                            </div>

                                            <div className="col-md-4">

                                                <label className="premium-label">
                                                    Last Name
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control premium-input"
                                                    name="Lname"
                                                    value={formData.Lname}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </div>

                                        <div className="row g-4 mt-1">

                                            <div className="col-md-6">

                                                <label className="premium-label">
                                                    WhatsApp Number
                                                </label>

                                                <div className="phone-input-group">

                                                    <select
                                                        className="form-select premium-input country-code-select"
                                                        name="CountryCode"
                                                        value={formData.CountryCode}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="+91">🇮🇳 +91</option>
                                                        <option value="+1">🇺🇸 +1</option>
                                                        <option value="+44">🇬🇧 +44</option>
                                                        <option value="+971">🇦🇪 +971</option>
                                                    </select>

                                                    <input
                                                        type="text"
                                                        className="form-control premium-input phone-number-input"
                                                        name="ContactNo"
                                                        value={formData.ContactNo}
                                                        onChange={handleChange}
                                                        placeholder="9876543210"
                                                        required
                                                    />

                                                </div>

                                            </div>

                                            <div className="col-md-6">

                                                <label className="premium-label">
                                                    Email Address
                                                </label>

                                                <input
                                                    type="email"
                                                    className="form-control premium-input"
                                                    name="EmailID"
                                                    value={formData.EmailID}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </div>

                                        

                                            <>
                                               

                                                <div className="row g-4 mt-1">

                                                    <div className="col-md-4">

                                                        <label className="premium-label">
                                                            State
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control premium-input"
                                                            name="State"
                                                            value={formData.State}
                                                            onChange={handleChange}
                                                        />

                                                    </div>

                                                    <div className="col-md-4">

                                                        <label className="premium-label">
                                                            City
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control premium-input"
                                                            name="City"
                                                            value={formData.City}
                                                            onChange={handleChange}
                                                        />

                                                    </div>

                                                    <div className="col-md-4">

                                                        <label className="premium-label">
                                                            Pincode
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control premium-input"
                                                            name="Pincode"
                                                            value={formData.Pincode}
                                                            onChange={handleChange}
                                                        />

                                                    </div>

                                                </div>
                                            </>

                                        


                                        <button
                                            type="submit"
                                            className="btn premium-register-btn w-100"
                                            disabled={loading || countdown.expired}
                                        >

                                            {countdown.expired ? (

                                                <>Registration Closed</>

                                            ) : loading ? (

                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                    ></span>

                                                    Processing...
                                                </>

                                            ) : (

                                                <>
                                                    Submit
                                                </>

                                            )}

                                        </button>

                                        <div className="course-highlights">

                                            <div className="highlight-item">
                                                🎓 Expert Mentorship
                                            </div>

                                            <div className="highlight-item">
                                                📈 Practical Learning
                                            </div>

                                            <div className="highlight-item">
                                                🏆 Certificate
                                            </div>

                                            <div className="highlight-item">
                                                💬 Live Q&A
                                            </div>

                                        </div>

                                        <div className="offer-box">

                                            <div>

                                                <small>
                                                    {countdown.expired
                                                        ? "Registration Closed"
                                                        : "Registration closes in"}
                                                </small>

                                                <h4>

                                                    {countdown.expired
                                                        ? "Offer Closed"
                                                        : `${String(countdown.days).padStart(2, "0")} Days : ${String(countdown.hours).padStart(2, "0")} Hours : ${String(countdown.minutes).padStart(2, "0")} Min : ${String(countdown.seconds).padStart(2, "0")} Sec`
                                                    }

                                                </h4>

                                            </div>

                                        </div>


                                        <div className="trust-badges">

                                            <div>
                                                🎓 Certificate
                                            </div>

                                            <div>
                                                📺 Live Sessions
                                            </div>

                                            <div>
                                                ♾ Lifetime Access
                                            </div>

                                            <div>
                                                💬 Doubt Support
                                            </div>

                                        </div>

                                        <div className="limited-seats-text">
                                            ⏳ Limited Seats Available
                                        </div>

                                        </fieldset>
                                    </form>

                                    <div className="testimonial-card">

                                        <p>

                                            ★★★★★

                                        </p>

                                        <p>

                                            "This workshop completely changed my understanding of the stock market. Highly recommended."

                                        </p>

                                        <b>

                                            — Rahul Sharma

                                        </b>

                                    </div>

                                </div>

                            </div>



                        </div>

                    </div>




                    <section className="apply-testimonials" aria-label="Student testimonials">
                        <div className="apply-testimonials__heading">
                            <span>Student experiences</span>
                            <h2>Learn with confidence</h2>
                        </div>
                        <div className="apply-testimonials__viewport">
                            <div
                                className="apply-testimonials__track"
                                style={{ transform: `translateX(-${activeTestimonial * 100}%)` }}
                            >
                                {studentTestimonials.map((testimonial) => (
                                    <article className="apply-testimonials__slide" key={testimonial.author}>
                                        <div className="apply-testimonials__stars" aria-label="5 out of 5 stars">★★★★★</div>
                                        <blockquote>“{testimonial.quote}”</blockquote>
                                        <footer>
                                            <strong>{testimonial.author}</strong>
                                            <span>{testimonial.detail}</span>
                                        </footer>
                                    </article>
                                ))}
                            </div>
                        </div>
                        <div className="apply-testimonials__dots" aria-hidden="true">
                            {studentTestimonials.map((testimonial, index) => (
                                <span className={index === activeTestimonial ? 'is-active' : ''} key={testimonial.author} />
                            ))}
                        </div>
                    </section>

                    {/* Mobile Sticky Apply Button */}

                    <div className="mobile-register-bar d-lg-none">

                        <button
                            className="mobile-register-btn"
                            disabled={countdown.expired}
                            onClick={() => {
                                if (countdown.expired) return;

                                const form = document.getElementById("registration-form");

                                if (form) {
                                    form.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start"
                                    });
                                }
                            }}
                        >
                            <div className="mobile-btn-title">
                                {countdown.expired ? "Registration Closed" : <>🚀 Reserve My Seat For{" "}
                                {Number(formattedFees) === 0 || formattedFees === "Free"
                                    ? "FREE"
                                    : `₹ ${formattedFees}`}</>}
                            </div>
                        </button>

                    </div>

                    <div
                        className={`modal fade ${showFormModal ? "show d-block" : ""}`}
                        tabIndex="-1"
                        style={{
                            background: "rgba(0,0,0,.6)"
                        }}
                    >

                        <div className="modal-dialog modal-dialog-scrollable modal-lg">

                            <div className="modal-content">

                                <div className="modal-header">

                                    <h5 className="modal-title">

                                        Course Registration

                                    </h5>

                                    <button
                                        className="btn-close"
                                        onClick={() => setShowFormModal(false)}
                                    ></button>

                                </div>

                                <div className="modal-body">

                                    <form onSubmit={handleSubmit}>
                                        {/* Always show these fields */}
                                        <div className="row mb-3">
                                            <div className="col-md-4"> <label htmlFor="Fname" className="form-label">First Name</label> <input type="text" className="form-control" id="Fname" name="Fname" value={formData.Fname} onChange={handleChange} required /> </div>
                                            <div className="col-md-4"> <label htmlFor="Mname" className="form-label">Middle Name</label> <input type="text" className="form-control" id="Mname" name="Mname" value={formData.Mname} onChange={handleChange} /> </div>
                                            <div className="col-md-4"> <label htmlFor="Lname" className="form-label">Last Name</label> <input type="text" className="form-control" id="Lname" name="Lname" value={formData.Lname} onChange={handleChange} required /> </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label htmlFor="ContactNo" className="form-label">WhatsApp Number (Ex: 823456789)</label> <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}> <select className="form-select" style={{ maxWidth: '110px' }} id="CountryCode" name="CountryCode" value={formData.CountryCode || "+91"} onChange={handleChange} required >
                                                    <option value="+91">🇮🇳 +91</option>
                                                    <option value="+93">🇦🇫 +93</option>
                                                    <option value="+355">🇦🇱 +355</option>
                                                    <option value="+213">🇩🇿 +213</option>
                                                    <option value="+376">🇦🇩 +376</option>
                                                    <option value="+244">🇦🇴 +244</option>
                                                    <option value="+54">🇦🇷 +54</option>
                                                    <option value="+61">🇦🇺 +61</option>
                                                    <option value="+43">🇦🇹 +43</option>
                                                    <option value="+880">🇧🇩 +880</option>
                                                    <option value="+32">🇧🇪 +32</option>
                                                    <option value="+55">🇧🇷 +55</option>
                                                    <option value="+359">🇧🇬 +359</option>
                                                    <option value="+1">🇨🇦 +1</option>
                                                    <option value="+86">🇨🇳 +86</option>
                                                    <option value="+57">🇨🇴 +57</option>
                                                    <option value="+385">🇭🇷 +385</option>
                                                    <option value="+420">🇨🇿 +420</option>
                                                    <option value="+45">🇩🇰 +45</option>
                                                    <option value="+20">🇪🇬 +20</option>
                                                    <option value="+372">🇪🇪 +372</option>
                                                    <option value="+33">🇫🇷 +33</option>
                                                    <option value="+49">🇩🇪 +49</option>
                                                    <option value="+30">🇬🇷 +30</option>
                                                    <option value="+852">🇭🇰 +852</option>
                                                    <option value="+36">🇭🇺 +36</option>
                                                    <option value="+62">🇮🇩 +62</option>
                                                    <option value="+98">🇮🇷 +98</option>
                                                    <option value="+964">🇮🇶 +964</option>
                                                    <option value="+353">🇮🇪 +353</option>
                                                    <option value="+972">🇮🇱 +972</option>
                                                    <option value="+39">🇮🇹 +39</option>
                                                    <option value="+81">🇯🇵 +81</option>
                                                    <option value="+254">🇰🇪 +254</option>
                                                    <option value="+965">🇰🇼 +965</option>
                                                    <option value="+371">🇱🇻 +371</option>
                                                    <option value="+961">🇱🇧 +961</option>
                                                    <option value="+370">🇱🇹 +370</option>
                                                    <option value="+60">🇲🇾 +60</option>
                                                    <option value="+52">🇲🇽 +52</option>
                                                    <option value="+977">🇳🇵 +977</option>
                                                    <option value="+31">🇳🇱 +31</option>
                                                    <option value="+64">🇳🇿 +64</option>
                                                    <option value="+234">🇳🇬 +234</option>
                                                    <option value="+47">🇳🇴 +47</option>
                                                    <option value="+92">🇵🇰 +92</option>
                                                    <option value="+63">🇵🇭 +63</option>
                                                    <option value="+48">🇵🇱 +48</option>
                                                    <option value="+351">🇵🇹 +351</option>
                                                    <option value="+974">🇶🇦 +974</option>
                                                    <option value="+40">🇷🇴 +40</option>
                                                    <option value="+7">🇷🇺 +7</option>
                                                    <option value="+966">🇸🇦 +966</option>
                                                    <option value="+65">🇸🇬 +65</option>
                                                    <option value="+421">🇸🇰 +421</option>
                                                    <option value="+27">🇿🇦 +27</option>
                                                    <option value="+82">🇰🇷 +82</option>
                                                    <option value="+34">🇪🇸 +34</option>
                                                    <option value="+94">🇱🇰 +94</option>
                                                    <option value="+46">🇸🇪 +46</option>
                                                    <option value="+41">🇨🇭 +41</option>
                                                    <option value="+886">🇹🇼 +886</option>
                                                    <option value="+66">🇹🇭 +66</option>
                                                    <option value="+90">🇹🇷 +90</option>
                                                    <option value="+971">🇦🇪 +971</option>
                                                    <option value="+44">🇬🇧 +44</option>
                                                    <option value="+1">🇺🇸 +1</option>
                                                    <option value="+84">🇻🇳 +84</option>
                                                    <option value="+263">🇿🇼 +263</option>
                                                </select> <input type="text" inputMode="numeric" pattern="\d{10}" maxLength="10" className="form-control" id="ContactNo" name="ContactNo" placeholder="8234567890" value={formData.ContactNo} onChange={handleChange} required style={{ flex: 1 }} />
                                                </div>
                                            </div>
                                            <div className="col-md-6"> <label htmlFor="EmailID" className="form-label">Email</label> <input type="email" className="form-control" id="EmailID" name="EmailID" value={formData.EmailID} onChange={handleChange} required /> </div>
                                        </div>
                                        <div className="row mb-3"> </div>
                                        {/* Show extra fields only if id !== "1" */} {id !== "1" && (<>
                                            <div className="row mb-3">
                                                <div className="col-md-4"> <label htmlFor="State" className="form-label">State</label> <input type="text" className="form-control" id="State" name="State" value={formData.State} onChange={handleChange} required /> </div>
                                                <div className="col-md-4"> <label htmlFor="City" className="form-label">City</label> <input type="text" className="form-control" id="City" name="City" value={formData.City} onChange={handleChange} required /> </div>
                                                <div className="col-md-4"> <label htmlFor="Pincode" className="form-label">Pincode</label> <input type="text" className="form-control" id="Pincode" name="Pincode" value={formData.Pincode} onChange={handleChange} required /> </div>
                                            </div>
                                        </>)}
                                        <div className="mt-4">

                                            <button
                                                type="submit"
                                                className="btn btn-success btn-lg w-100"
                                                disabled={loading}
                                            >

                                                {loading ? (

                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>

                                                        Please Wait...
                                                    </>

                                                ) : (

                                                    <>
                                                        🚀 Apply Now
                                                    </>

                                                )}

                                            </button>

                                        </div>

                                    </form>

                                </div>

                            </div>

                        </div>

                    </div>
        </section>

    );
};
export default ApplyCourse;
